shadow$provide[318] = function(global,require,module,exports) {

};